import * as React from 'react';

import type { CMLDefinition } from 'bundles/compound-assessments/types/FormParts';
import ThreadsListEntry from 'bundles/discussions/components/personalization-discussionsBody/ThreadsListEntry';
import type { AuthorProfile } from 'bundles/discussions/lib/types';
import * as discussionsUrl from 'bundles/discussions/utils/discussionsUrl';
import { TrackedReactLink } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/discussions';

export type SearchResultEntryType = {
  id: string;
  title: string;
  snippet: CMLDefinition;
  content: CMLDefinition;
  threadName: string;
  courseForumQuestionId?: string;
  creator: AuthorProfile;
  createdAt?: number;
  forumId?: string;
};

type SearchResultEntryProps = {
  entry: SearchResultEntryType;
  index: number;
  page: number;
  query: string;
  forumLink: string;
};

const SearchResultEntry = (props: SearchResultEntryProps) => {
  const { entry } = props;

  const threadEntry = (
    <ThreadsListEntry
      key={entry.id + discussionsUrl.getDeepLink(props.forumLink, props.entry)}
      threadUrl={entry?.title && discussionsUrl.getDeepLink(props.forumLink, props.entry)}
      profile={entry.creator}
      timestamp={entry.createdAt}
      threadName={entry.threadName}
      questionUserId={entry.creator?.id}
      entry={{
        ...entry,
        content: {
          question: entry.title,
          details: entry.content,
        },
        question: entry.content,
        questionId: entry.courseForumQuestionId,
      }}
      questionId={entry.courseForumQuestionId}
      metadataLabel={_t('posted')}
      enableTranslation={false}
    />
  );

  const threadEntryWithTrackedLink = !entry?.title && (
    <TrackedReactLink
      to={discussionsUrl.getDeepLink(props.forumLink, entry)}
      trackingName="thread_list_entry"
      aria-label={entry.title}
      data={{
        question_id: entry.courseForumQuestionId,
        question_user_id: entry.creator?.id,
      }}
      className="nostyle"
    >
      {threadEntry}
    </TrackedReactLink>
  );

  return threadEntryWithTrackedLink || threadEntry;
};

export default SearchResultEntry;
